<script>
import UtilsMixin from "@/mixins/utils";
import VueI18n
  from "vue-i18n";
import {loadLocaleMessages} from "@/i18n";
import {mapState} from "vuex";
const i18nn = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  messages: loadLocaleMessages(),
})
export default {
  components: {},
  i18n: i18nn,
  props: {
    data: Object,
    me: Object
  },
  data() {
    return {
      timePrint: this.timeCreate()
    }
  },
  computed: {
    ...mapState('auth',['currencyType'])
  },
  mounted() {
    setTimeout(()=>{
      i18nn.locale = this.currencyType === 'USD' ? 'en' : 'vi'
    },1000)
  },
  mixins: [UtilsMixin],
  methods: {
    timeCreate() {
      let date = new Date(Math.round(this.data.created_at));
      return {
        year: date.getFullYear(),
        month: date.getMonth() >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`,
        day: date.getDate() >= 10 ?date.getDate() : `0${date.getDate()}`,
        hour: date.getHours(),
        min: date.getMinutes(),
        sec: date.getSeconds(),
      }
    }
  }
};
</script>

<template>
  <div class="page">
    <div class="d-flex justify-content-between">
      <template v-if="data.distributor">
        <div v-if="data.distributor.extra_data">
          <p class="text-uppercase mb-2 font-size-16"><b>{{ data.distributor.extra_data.distributor_name }}</b></p>
          <p class="text-uppercase mb-2 font-size-16">{{ $t('print.address_x',{value: data.distributor.extra_data.distributor_address}) }}</p>
          <p class="text-uppercase mb-0 font-size-16">{{ $t('print.tel_x',{value: data.distributor.extra_data.distributor_phone}) }}</p>
        </div>
        <div v-else>
          <p class="text-uppercase mb-2 font-size-16"><b>{{ data.distributor.distributor_name }}</b></p>
          <p class="text-uppercase mb-2 font-size-16">{{ $t('print.address_x',{value: data.distributor.distributor_address}) }}</p>
          <p class="text-uppercase mb-0 font-size-16">{{ $t('print.tel_x',{value: data.distributor.distributor_phone}) }}</p>
        </div>
      </template>
      <div>
        <img :src="`https://chart.googleapis.com/chart?chs=100x100&cht=qr&chld=L|0&chl=${data.id}`" alt="QR">
      </div>
    </div>
    <h2 class="text-uppercase text-center pt-3">{{$t('print.delivery_notes')}}</h2>
    <p class="text-center">{{$t('print.number_x',{value: data.po_id + '/' + data.order_code})}}</p>
    <div class="print-content">
      <p class="font-size-16 mb-2" v-if="data.created_user">{{$t('print.order_creator_x',{value: data.created_user.name + ' - ' + data.created_user.phone})}}</p>
      <p v-if="data.customer_store" class="font-size-16 mb-2">{{$t('print.order_point_x',{value: data.customer_store.store_name})}}</p>
      <p v-if="data.customer_store" class="font-size-16 mb-2">{{$t('print.receiver_x',{value: data.customer_store.store_contact_name})}}</p>
      <p v-else class="font-size-16 mb-2">{{$t('print.receiver_x',{value: data.delivery_info.contact_name})}}</p>
      <p class="font-size-16 mb-2">{{$t('print.address_x',{value: data.delivery_info.delivery_address})}}</p>
      <p class="font-size-16 mb-2">{{$t('print.tel_x',{value: data.delivery_info.contact_phone})}}</p>
      <p class="font-size-16 mb-2">{{$t('print.note_x',{value: data.note})}}</p>
      <p class="font-size-16">{{$t('print.note_other_x',{value: data.stocker_note})}}</p>
    </div>
    <table class="table table-bordered font-size-16 border-black">
      <tr>
        <th>{{$t('print.code')}}</th>
        <th>{{$t('print.item_name')}}</th>
        <th>{{$t('print.unit')}}</th>
        <th>{{$t('print.quantity')}}</th>
        <th>{{$t('print.price')}}</th>
        <th>{{$t('print.price_after_discount')}}</th>
        <th>{{$t('print.discount')}}</th>
        <th>{{$t('print.price_before_discount')}}</th>
      </tr>
      <tr v-for="(item, key) of data.details" :key="key">
        <td>{{ item.ids_sku }}</td>
        <td>{{ item.item_name }}</td>
        <td>{{ item.unit_name }}</td>
        <td class="font-weight-bold">{{ item.delivery_qty }}</td>
        <td>{{ item.discount_amount !== 0 ? formatPrice(item.price_basis,true) : formatPrice(item.price,true) }}</td>
        <td>{{ item.amount_vat ? formatPrice(item.amount + item.amount_vat + item.discount_amount) : formatPrice(item.amount + item.discount_amount) }}</td>
        <td>{{ formatPrice(item.discount_amount) }}</td>
        <td>{{ item.amount_vat ? formatPrice(item.amount + item.amount_vat) : formatPrice(item.amount) }}</td>
      </tr>
      <!-- <tr>
        <td colspan="7">Tổng tiền trước chiết khấu</td>
        <td class="font-weight-medium">{{ formatPrice(data.final_amount + data.item_discount_amount) }}</td>
      </tr>
      <tr>
        <td colspan="7">Tổng tiền chiết khấu</td>
        <td class="font-weight-medium">{{ formatPrice(data.item_discount_amount) }}</td>
      </tr> -->
      <tr>
        <td colspan="5">{{$t('print.amount')}}</td>
        <td class="font-weight-bold">{{ formatPrice(data.amount + data.item_discount_amount) }}</td>
        <td class="font-weight-bold">{{ formatPrice(data.item_discount_amount) }}</td>
        <td class="font-weight-bold">{{ formatPrice(data.amount) }}</td>
      </tr>
      <!-- <tr>
        <td colspan="7">Tạm tính</td>
        <td class="font-weight-bold">{{ formatPrice(data.amount) }}</td>
      </tr> -->
      <tr>
        <td colspan="7" class="font-weight-bold">{{$t('print.discount_amount')}}</td>
        <td class="font-weight-bold font-weight-bold">{{ formatPrice(data.bill_discount_amount) }}</td>
      </tr>
      <tr>
        <td colspan="7" class="font-weight-bold">{{$t('print.total_amount')}}</td>
        <td class="font-weight-bold font-weight-bold">{{ formatPrice(data.final_amount) }}</td>
      </tr>
      <tfoot class="footer-repeat no-border">
         <!-- add repeated tfoot for extra space -->
         <tr class="no-border">
            <td class="no-border">&nbsp;</td>
         </tr>
      </tfoot>
    </table>
    <!-- <div>
      <p class="font-size-16">Khuyến mãi: {{ data.promotion_name }}</p>
      <p class="font-size-16">Tạm tính: {{ formatPrice(data.amount) }}</p>
      <p class="font-size-16">Chiết khấu: {{ formatPrice(data.bill_discount_amount) }}</p>
      <p class="font-size-16">Tổng tiền: {{ formatPrice(data.final_amount) }}</p>
    </div> -->
    <div class="print-footer d-flex justify-content-around font-size-16 pt-3">
      <div>
        <p class="invisible">-</p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.receiver')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name_and_confirmation_if_not_yet_paid')}})</p>
      </div>
      <div>
        <p>{{$t('print.day_month_year', {d: timePrint.day, m: timePrint.month, y: timePrint.year})}}</p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.deliver')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
    </div>
    <!-- <p style="page-break-after:always;"></p> -->
  </div>
</template>